// extracted by mini-css-extract-plugin
module.exports =  {"description":"HhNatUK3xoPVm5EvDjJO"};